import React, {FC, useEffect, useState} from 'react'
import {useIntl} from 'react-intl'

import {toAbsoluteUrl} from '_metronic/helpers'

const MESSAGE_IDS = [
  'ONBOARDING_WIZARD.SAMPLE_DATA_LOADER.SEEDING',
  'ONBOARDING_WIZARD.SAMPLE_DATA_LOADER.SETTING_UP',
  'ONBOARDING_WIZARD.SAMPLE_DATA_LOADER.BUILDING_SCHOOL',
  'ONBOARDING_WIZARD.SAMPLE_DATA_LOADER.ALMOST_THERE',
] as const

const MESSAGE_INTERVAL_MS = 2500

const OnboardingSampleDataLoader: FC = () => {
  const intl = useIntl()
  const [messageIndex, setMessageIndex] = useState(0)

  useEffect(() => {
    const timer = window.setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % MESSAGE_IDS.length)
    }, MESSAGE_INTERVAL_MS)

    return () => window.clearInterval(timer)
  }, [])

  const messageId = MESSAGE_IDS[messageIndex]

  return (
    <div
      className='onboarding-loading-overlay onboarding-sample-data-loader'
      role='status'
      aria-live='polite'
      aria-busy='true'
    >
      <div className='onboarding-sample-data-loader-content'>
        <img
          src={toAbsoluteUrl('media/logos/LogoAnim1.gif')}
          alt={intl.formatMessage({id: 'ONBOARDING_WIZARD.LOADING'})}
          className='onboarding-loading-logo'
        />
        <p key={messageId} className='onboarding-sample-data-loader-message'>
          {intl.formatMessage({id: messageId})}
        </p>
      </div>
    </div>
  )
}

export default OnboardingSampleDataLoader
